export const OVERLAY_IDS = {
  roomDetails: 'roomDetails',
  preferences: 'preferences',
  hotelGallery: 'hotelGallery'
} as const
